<ng-content></ng-content>
@if (status?.busy) {
  <div class="button-inline-indicator"
  >_</div>
}